export const PortalKeys = {
    TiberManagementPortal: 'administration',
    TiberAdmissionsPortal: 'admissions',
    TiberStudentPortal: 'student',
    TiberDirectorsPortal: 'director',
    TiberCourseDirectorPortal: 'course-director',
    TiberInstructorPortal: 'instructor',
    TiberStudentSurvey: 'survey',
} as const;

export type PortalKey = typeof PortalKeys[keyof typeof PortalKeys];